import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import Draw from 'ol/interaction/Draw';
import Map from 'ol/Map';
import View from 'ol/View';

import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
  Interaction,
} from 'ol/interaction';
import axios from 'src/app/Service/axios';
import { Feature, Overlay, } from 'ol/index';
import { OSM, Vector as VectorSource } from 'ol/source';
import { Point } from 'ol/geom';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { NotificationService } from 'src/app/Service/notification.service';
import { Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { useGeographic } from 'ol/proj';
import { Chart,registerables  } from 'chart.js';
declare let $: any;

@Component({
  selector: 'test',
  templateUrl: './test.component.html',
  styleUrls: ["./test.component.css"]
})
export class TestComponent implements OnInit {
  map: any = {};

  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService
  ) {
    Chart.register(...registerables);
  }

  ngOnInit(): void {
  }
  keyword = 'name';
  data = [
    {
      id: 1,
      name: 'Georgia'
    },
     {
       id: 2,
       name: 'Usa'
     },
     {
       id: 3,
       name: 'England'
     }
  ];


  selectEvent(item:any) {
    // do something with selected item
  }

  onChangeSearch(val: any) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e:any){
    // do something when input is focused
  }

}
